module.exports = __webpack_public_path__ + "img/copy-white.f86e944.svg";